import * as React from 'react'
import { connect } from 'react-redux'
import { PhoneSystemNumberEditFormComponent } from './PhoneSystemNumberEditForm'
import { reduxForm } from 'redux-form'
import { flow } from 'lodash'

const formName = 'phoneSystemNumberEdit'

export interface INumberFormData {
  phoneSystemNumberId: string
  customerReference: string
  flowId: string
}

export interface IPhoneSystemNumberEditFormProps {
  onAfterSubmit: () => undefined
  initialValues?: INumberFormData
}

const stateToProps = () => ({})
const dispatchToProps = {}

export const PhoneSystemNumberEditForm = flow<any, any, React.SFC<IPhoneSystemNumberEditFormProps>>(
  reduxForm({ form: formName }),
  connect(stateToProps, dispatchToProps)
)(PhoneSystemNumberEditFormComponent)



// WEBPACK FOOTER //
// src/features/PhoneSystem/PhoneSystemNumberEditForm/PhoneSystemNumberEditForm.container.ts